import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'defaultValue',
    standalone: false
})
export class DefaultValuePipe implements PipeTransform {

  transform(value: unknown, defaultValue?: any): unknown {
    if(value) {
      return value;
    }
    if(defaultValue) {
      return defaultValue;
    }
    return 'n/A';
  }

}


